import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/_shared/shared.service';

@Component({
  selector: 'app-admin-reservations',
  templateUrl: './admin-reservations.component.html',
  styleUrls: ['./admin-reservations.component.scss']
})
export class AdminReservationsComponent implements OnInit {

  activeTab = 1;

  tabToday = {
    refreshUrl: 'reservations/list',
    detailUrl: 'admin/reservations',
    detailId: 'id_reservation',
    params: { tab: 'today' },
    cols: [
      { type: 'time', attr: 'date_from', header: 'Od' },
      { type: 'time', attr: 'date_to', header: 'Do' },
      { type: 'text', attr: 'location_name', header: 'Lokace' },
      { type: 'text', attr: 'station_name', header: 'Stanice' },
      { type: 'text', attr: 'user_name', header: 'Uživatel' },
      { type: 'text', attr: 'client_name', header: 'Klient' },
      { type: 'text', attr: 'license_plate', header: 'SPZ' },
      { type: 'number', attr: 'energy_kwh', suffix: ' kWh', header: 'Energie' },
      { type: 'translate', attr: 'status', header: 'Status' }
    ]
  };

  tabUpcoming = {
    refreshUrl: 'reservations/list',
    detailUrl: 'admin/reservations',
    detailId: 'id_reservation',
    params: { tab: 'upcoming' },
    cols: [
      { type: 'datetime', attr: 'date_from', header: 'Datum a čas' },
      { type: 'text', attr: 'location_name', header: 'Lokace' },
      { type: 'text', attr: 'station_name', header: 'Stanice' },
      { type: 'text', attr: 'user_name', header: 'Uživatel' },
      { type: 'text', attr: 'client_name', header: 'Klient' },
      { type: 'text', attr: 'license_plate', header: 'SPZ' },
      { type: 'number', attr: 'energy_kwh', suffix: ' kWh', header: 'Energie' },
      { type: 'translate', attr: 'status', header: 'Status' }
    ]
  };

  tabAll = {
    refreshUrl: 'reservations/list',
    detailUrl: 'admin/reservations',
    detailId: 'id_reservation',
    cols: [
      { type: 'datetime', attr: 'date_from', header: 'Datum a čas' },
      { type: 'text', attr: 'location_name', header: 'Lokace' },
      { type: 'text', attr: 'station_name', header: 'Stanice' },
      { type: 'text', attr: 'user_name', header: 'Uživatel' },
      { type: 'text', attr: 'client_name', header: 'Klient' },
      { type: 'text', attr: 'license_plate', header: 'SPZ' },
      { type: 'number', attr: 'energy_kwh', suffix: ' kWh', header: 'Energie' },
      { type: 'translate', attr: 'status', header: 'Status' }
    ]
  };

  constructor(
    public shared: SharedService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.activeTab = this.shared.loadActiveTab('rep_admin_reservations_tab', false, 1);
  }

  onTabChange(): void {
    this.shared.saveActiveTab('rep_admin_reservations_tab', false, this.activeTab);
  }
}
